import { clearDocument, IndexeddbPersistence } from "y-indexeddb";
import type * as Y from "yjs";

/** IndexedDB database name for a room (one per room topic). */
export function storageName(topic: string): string {
  return `codeshare:room:${topic}`;
}

export interface Persistence {
  /** Resolves once stored state has been loaded into the doc. */
  readonly whenLoaded: Promise<void>;
  /** Stops persisting (keeps what's stored). */
  destroy(): Promise<void>;
}

/**
 * Keeps a room's document in IndexedDB so a reload (or rejoining later) starts from local state
 * and then merges with peers. Load it before connecting so local edits aren't lost.
 */
export function persistDocument(doc: Y.Doc, topic: string): Persistence {
  const persistence = new IndexeddbPersistence(storageName(topic), doc);
  return {
    whenLoaded: persistence.whenSynced.then(() => {}),
    destroy: () => persistence.destroy(),
  };
}

/** Deletes everything stored locally for a room ("Leave & forget"). */
export async function forgetDocument(topic: string): Promise<void> {
  await clearDocument(storageName(topic));
}
